import styled, { css } from 'styled-components';
import { m32 } from '../../styles/typography';

export const Heading = styled.h1<{ center?: boolean }>`
  ${m32}
  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}
`;
